import { render, staticRenderFns } from "./CheckboxComponent.vue?vue&type=template&id=f4377b76&scoped=true"
import script from "./CheckboxComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxComponent.vue?vue&type=script&lang=js"
import style0 from "./CheckboxComponent.vue?vue&type=style&index=0&id=f4377b76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4377b76",
  null
  
)

export default component.exports